import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Box, Text, DropButton, Button } from 'grommet';
import { FormDown } from 'grommet-icons';
import styled from 'styled-components';
const StyledSpan = styled.span`
  padding-top: 3px;
  svg {
    fill: ${({
  isActive,
  theme
}) => isActive ? theme.global.colors['sidebar-svg-active'] + `!important` : theme.global.colors['sidebar-svg'] + `!important`};
  }
`;
const StyledBox = styled(Box)`
  padding: 10px;
  background-color: #fff;
  white-space: nowrap;
  &:hover {
    background: ${({
  theme
}) => theme.global.colors['sidebar-label-active-background'] + `!important`};
  }
`;
const StyledButton = styled(DropButton)`
  padding: 12px 10px;
  margin: 0;
  &:hover {
    background: ${({
  theme
}) => theme.global.colors['sidebar-label-active-background'] + `!important`};
  }
`;
const MoreLeftItems = ({
  subItems,
  theme,
  label
}) => {
  return /*#__PURE__*/React.createElement(StyledButton, {
    plain: true,
    alignSelf: "center",
    theme: theme,
    margin: {
      vertical: 'small'
    },
    dropContent: renderItems(subItems, theme),
    dropAlign: {
      top: 'bottom'
    },
    dropProps: {
      style: {
        backgroundColor: '#fff',
        transition: 'all 0.5s ease 0s',
        borderRadius: '4px',
        boxShadow: 'rgb(0 0 0 / 10%) 0px 4px 10px 0px',
        'min-width': '190px'
      }
    }
  }, /*#__PURE__*/React.createElement(Button, {
    plain: true,
    as: "div",
    style: {
      display: 'flex'
    },
    reverse: true,
    icon: /*#__PURE__*/React.createElement(FormDown, {
      size: "small"
    }),
    label: /*#__PURE__*/React.createElement(Text, {
      size: "large"
    }, " ", label, " ")
  }));
};
const itemBox = (i, index, theme) => {
  return /*#__PURE__*/React.createElement(Link, {
    key: index,
    to: {
      pathname: '/' + i.path,
      state: {
        url: i.url
      }
    }
  }, /*#__PURE__*/React.createElement(StyledBox, {
    focusIndicator: false,
    direction: "row",
    gap: "small",
    align: "end"
  }, i.icon && typeof i.icon === 'string' ? /*#__PURE__*/React.createElement(StyledSpan, {
    style: {
      display: 'flex'
    },
    dangerouslySetInnerHTML: {
      __html: i.icon.replaceAll("sidebar-svg", theme?.global?.colors['sidebar-svg'])
    }
  }) : i.icon, /*#__PURE__*/React.createElement(Text, null, i.label)));
};
const renderItems = (subItems, theme) => /*#__PURE__*/React.createElement(React.Fragment, null, subItems.map((i, index) => i.children ? /*#__PURE__*/React.createElement(DropButton, {
  focusIndicator: false,
  key: index,
  dropContent: renderItems(i.children, theme),
  dropProps: {
    align: {
      top: 'bottom',
      left: 'right'
    }
  }
}, /*#__PURE__*/React.createElement(StyledBox, {
  direction: "row",
  align: "end",
  gap: "small",
  focusIndicator: false
}, i.icon && typeof i.icon === 'string' ? /*#__PURE__*/React.createElement(StyledSpan, {
  style: {
    display: 'flex'
  },
  dangerouslySetInnerHTML: {
    __html: i.icon
  }
}) : i.icon, /*#__PURE__*/React.createElement(Text, null, i.label), /*#__PURE__*/React.createElement(FormDown, {
  size: "small",
  style: {
    marginLeft: 'auto'
  }
}))) : itemBox(i, index, theme)));
MoreLeftItems.propTypes = {
  subItems: PropTypes.any,
  theme: PropTypes.any,
  label: PropTypes.string
};
export default MoreLeftItems;